import { render, staticRenderFns } from "./IconGitpull.vue?vue&type=template&id=d48ff35a"
import script from "./IconGitpull.vue?vue&type=script&lang=js"
export * from "./IconGitpull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports